import { routerMiddleware } from "react-router-redux";
import { Middleware } from "redux";

import { history } from "redux/store/history";

const router = routerMiddleware(history) as Middleware;

export default router;
